module.exports = __webpack_public_path__ + "img/ras-bg@2x.9b7a4034.png";